/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Datefrom1Inputs */

const en_datefrom1 = /** @type {(inputs: Datefrom1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`From`)
};

const de_datefrom1 = /** @type {(inputs: Datefrom1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Von`)
};

/**
* | output |
* | --- |
* | "From" |
*
* @param {Datefrom1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const datefrom1 = /** @type {((inputs?: Datefrom1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Datefrom1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_datefrom1(inputs)
	return de_datefrom1(inputs)
});
export { datefrom1 as "dateFrom" }